<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                续签基站图层
                <small>续签基站图层</small>
            </h1>
            <ol class="breadcrumb">
                <li><a href="#"><i class="fa fa-dashboard"></i> 续签基站图层</a></li>
                <li class="active">续签基站图层</li>
            </ol>
        </section>

        <!-- Main content -->
        <section class="content">
            <div id="map_container" style="width:100%;height:88vh;"></div>
        </section>
        <!-- /.content -->
    </div>
</template>
<script>

  import AMap from 'AMap'

  var map
  var markers = []
  var selectedmark
  var infoWindow // 弹出框
  var geolocation

  export default {
    name: 'index',
    data () {
      return {}
    },
    mounted () {
      this.init()  // 加载地图
      this.getstation()
    },
    methods: {
      init: function () {
        var self = this
        map = new AMap.Map('map_container', {
          center: [116.397477, 39.908692],
          resizeEnable: true,
          zoom: 14,
          layers: [new AMap.TileLayer.Satellite()],
        })
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
          map.addControl(new AMap.ToolBar())
          map.addControl(new AMap.Scale())
        })

        map.plugin(['AMap.Geolocation', 'AMap.ToolBar', 'AMap.InfoWindow'], function () {
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,//是否使用高精度定位，默认:true
            timeout: 5000,          //超过10秒后停止定位，默认：无穷大
            maximumAge: 0,           //定位结果缓存0毫秒，默认：0
            convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: false,        //显示定位按钮，默认：true
            buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
            buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            showMarker: false,        //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: false,        //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: false      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          })
          map.addControl(new AMap.ToolBar())
          map.addControl(geolocation)
          geolocation.getCurrentPosition()
          AMap.event.addListener(geolocation, 'complete', self.onComplete)
          AMap.event.addListener(geolocation, 'error', self.onError)
        })
      },
      onError: function (data) {
        var self = this
        console.log('定位失败~~~')
        centerMarker = new AMap.Marker({
          map: map,
          position: [116.397477, 39.908692],
          draggable: false, //是否可以移动
          zIndex: 102,
          icon: new AMap.Icon({
            size: new AMap.Size(40, 40),  //图标大小
            image: imagehost + '/conter_point.png'
          })
        })
        self.getstation()
        map.on('moveend', function () { //地图平移结束事件
          self.getstation()
        })
      },
      onComplete: function () {
        var self = this
        self.getstation()
        map.on('moveend', function () { //地图平移结束事件
          self.getstation()
        })
      },

      getstation: function () {
        var self = this
        self.axios.get('/static/stationList.json').then((response) => {
          console.log(response.data)
          var stations = response.data
          var marker
          var markericon
          var markericontype
          var markersizewidth
          var markersizeheight
          var markercontent

          for (var i = 0; i < stations.length; i++) {

            switch (stations[i].type) {
              case '中国移动': {
                markericontype = 'cmcc'
                break
              }
              case '中国电信': {
                markericontype = 'telecom'
                break
              }
              case '中国联通': {
                markericontype = 'unicom'
                break
              }
              case '中国铁塔': {
                markericontype = 'tower'
                break
              }
              default: {
                console.log('存在未知基站:' + stations[i].id)
                continue
              }
            }

            markericon = new AMap.Icon({
              image: '/static' + '/icon_' + markericontype + '_40.png',
              size: new AMap.Size(40, 40),
            })

            marker = new AMap.Marker({
              map: map,
              icon: markericon,
              position: stations[i].center.split(','),
              zIndex: 101,
              size: new AMap.Size(10, 10),
              offset: new AMap.Pixel(-(20), -(20)),
              extData: stations[i],
            })
            marker.on('click', this.markerClick)
            markers.push(marker)
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      markerClick: function (e) {
        selectedmark = e.target
        var extData = e.target.getExtData()
        console.log(extData)
        var info = []
        info.push('<div style=\'padding:0px 0px 0px 4px;\'><b>' + extData['type'] + '</b> ' + extData['name'])
        info.push('地址 :' + extData['address'] + '</div></div>')
        infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, 0) })
        infoWindow.setContent(info.join(','))
        infoWindow.open(map, e.target.getPosition())
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/renewStation.vue